import React, { useState, useEffect } from "react";
import PiwikProProvider from '@piwikpro/next-piwik-pro';
import { makeStyles } from "@mui/styles";
import { Grid } from "@mui/material";
import Footer from "./Footer";
import Header from "./Header";
import theme from "../../theme";
import {useTranslation} from "react-i18next";
import moment from "moment";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';

const useStyles = makeStyles({
	wrapper: {
		border: "16px solid #041196",
		boxSizing: "border-box",
		paddingTop: "0 !important",
		width: "100%",
		minHeight: "100vh",
		display: "flex",
		flexDirection: "column",
		[theme.breakpoints.down('md')]: {
			border: "none"
		}
	},
	publicPageWrapper: {
		padding: "0 !important",
		flex: "1 0 auto",
		alignItems: "flex-start",
		alignContent: "flex-start"
	},
	footer: {
		flexShrink: 0
	},
	invoicingAlertMessage: {
		background: "rgb(255, 0, 0)",
		width: "100%",
		padding: "24px 24px",
		color: "rgb(255, 255, 255)",
		fontSize: "16px"
	},
	maintenanceMessage: {
		margin: "auto",
		border: "2px solid #041196",
		borderRadius: "10px",
		padding: "10px 24px 24px",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		width: "60%",
		maxWidth: "40%",
		minHeight: "180px",
		color: "rgb(4 17 150)",
		fontSize: "20px",
		background: "rgb(162 170 255 / 32%)",
		[theme.breakpoints.down('lg')]: {
			maxWidth: "50%",
		},
		[theme.breakpoints.down('md')]: {
			maxWidth: "80%",
		},
		"& > svg": {
			marginBottom: "20px",
			fontSize: "56px",
			color: "orange"
		}
	}
});

interface WrapperProps {
	children: React.ReactNode;
}

const Wrapper = ({ children }: WrapperProps) => {
	const classes = useStyles();
	const { i18n } = useTranslation();
	const { t } = useTranslation("common");
	const [displayAlertMessage, setDisplayAlertMessage] = useState(false);

	useEffect(() => {
		// const now = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
		// const startDate = moment("02/03/2025 10:00:00", "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss");
		// const endDate = moment("02/03/2025 22:00:00", "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss");
		// const isBetweenMaintenance = moment(now, "YYYY-MM-DD HH:mm:ss").isBetween(startDate, endDate, "minute", '[]');

		// if (isBetweenMaintenance) {
		// 	setDisplayAlertMessage(true);
		// }
	}, []);

	return (
		<div className={classes.wrapper}>
      <PiwikProProvider
          containerId="cc11ed7b-4c59-4065-b280-aa21fdfbd0f8"
          containerUrl="https://octa1800.containers.piwik.pro"
      >
				<Grid container item className={classes.publicPageWrapper}>
					<Header />
					{(displayAlertMessage) ? (
						<Grid container item justifyContent="center" alignItems="center" style={{ minHeight: "500px" }}>
								<div className={classes.maintenanceMessage}>
									<ReportProblemIcon />
									<Grid container item>
										<span>{t("notificationMessages.maintenanceMessage")}</span>
									</Grid>
								</div>
						</Grid>
					) : (
						<>{children}</>
					)}
				</Grid>
				<Grid container item className={classes.footer}>
					{i18n.language && (
						<Footer/>
					)}
				</Grid>
      </PiwikProProvider>
		</div>
	);
};

export default Wrapper;
